module.exports = __webpack_public_path__ + "static/media/arrowLeft.03a56ecf.svg";